import { render } from "./UpdateAttached.vue?vue&type=template&id=48fffc41"
import script from "./UpdateAttached.vue?vue&type=script&lang=js"
export * from "./UpdateAttached.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"UpdateAttached.vue"]])

export default __exports__